/**
 * 数据图标筛选
 */
export const creatTitles: any = {
  1: '话数',
  2: '任务数',
  3: '审批数'
};

/**
 * 统计明细-查看周期
 */
export const statisticDetailTimes: any = [{ id: 1, name: '周' }, { id: 2, name: '月' }];

/**
 * 统计-图标颜色
 */
export const statisticChartColors: any = ['#71CDFF', '#9C71FF', '#FFE771', '#2F8ADB', '#FF718A'];

/**
 * 格子单位
 * 单位类型 1：格、2：页、3：卡、4：章、5：集、6：秒 默认值: 1
 */
export const unitTypes: any = [{
    label: '格',
    value: 1
  }, {
    label: '页',
    value: 2
  }, {
    label: '卡',
    value: 3
  }, {
    label: '章',
    value: 4
  }, {
    label: '集',
    value: 5
  }, {
    label: '秒',
    value: 6
  }];
